import { useId } from 'react';
export interface ShimmerProps {
  id: string;
  highlightColor: string;
  bgColor?: string;
  dur?: string;
  pause?: string;
}

const Shimmer = ({
  highlightColor,
  bgColor = 'currentColor',
  dur = '900ms',
  pause = '400ms',
  id,
}: ShimmerProps) => {
  const shimmer_start_id = `shimmer_start_${useId()}`;
  const shimmer_end_id = `shimmer_end_${useId()}`;

  return (
    <defs>
      <linearGradient id={id} gradientTransform="rotate(2)" x1="-1" x2="0">
        <stop offset="0%" stopColor={bgColor} />
        <stop offset="30%" stopColor={highlightColor} />
        <stop offset="60%" stopColor={bgColor} />
        <stop offset="100%" stopColor={bgColor} />
        <animate
          id={shimmer_start_id}
          attributeName="x1"
          values="-1.0;1"
          dur={dur}
          begin={`0s;${shimmer_start_id}.end+${pause}`}
          fill="freeze"
        />
        <animate
          id={shimmer_end_id}
          attributeName="x2"
          values="0.0;2.0"
          dur={dur}
          begin={`0s;${shimmer_end_id}.end+${pause}`}
          fill="freeze"
        />
      </linearGradient>
    </defs>
  );
};

export default Shimmer;
